import { API } from '@Providers';
import type { FosterStartPayload } from '@FosterModule';

export default async function (payload: FosterStartPayload) {
  const endpoint = '/api/shelter/foster/start-foster';

  return API({ endpoint, method: 'post', payload });
}
